import React from "react";
import { useAtom } from "jotai";
import { useSetAtom } from "jotai/index";

import { HorizontalSpace } from "components/HorizontalSpace/HorizontalSpace";
import { Button, EButtonVariant } from "components/Button/Button";

import {
  setConfirmationModalAtom,
  setDocumentModalAtom,
} from "../../atoms/modalAtom/modalAtom";
import {
  openedDocumentAtom,
  selectedDocumentAtom,
} from "../../atoms/documentsAtom";
import useDocuments from "../../hooks/useDocuments";

import styles from "./styles.module.css";

interface FooterProps {}

export const Footer = ({}: FooterProps): JSX.Element => {
  const {
    createDocumentAndOpen,
    deleteDocument,
    conductDocument,
    unConductDocument,
  } = useDocuments();
  const setShowDocumentModal = useSetAtom(setDocumentModalAtom);
  const setConfirmation = useSetAtom(setConfirmationModalAtom);
  const [selectedDocument] = useAtom(selectedDocumentAtom);
  const [, setOpenedDocument] = useAtom(openedDocumentAtom);

  const onDeleteClick = () => {
    if (!selectedDocument?.number) return;
    setConfirmation({
      title: `Вы действительно хотите удалить документ с номером "${selectedDocument.number}"?`,
      onConfirm: deleteDocument,
    });
  };

  const onConductClick = () => {
    if (!selectedDocument?.number) return;
    setConfirmation({
      title: `Вы действительно хотите провести документ с номером "${selectedDocument.number}"?`,
      onConfirm: conductDocument,
      confirmText: "Провести",
    });
  };

  const onUnConductClick = () => {
    if (!selectedDocument?.number) return;
    setConfirmation({
      title: `Вы действительно хотите отменить проведение документа с номером "${selectedDocument.number}"?`,
      onConfirm: unConductDocument,
      confirmText: "Подтвердить",
      height: 240,
    });
  };

  const onEditClick = () => {
    if (!selectedDocument?.number) return;
    setOpenedDocument({ ...selectedDocument });
    setShowDocumentModal();
  };

  return (
    <div className="flex flex-row justify-between items-center">
      <div className="flex flex-row justify-between items-center">
        <Button onClick={createDocumentAndOpen} icon="plus" />
        <HorizontalSpace size={11} />
        <Button
          icon="delete"
          onClick={onDeleteClick}
          disabled={!selectedDocument}
        />
        <HorizontalSpace size={11} />
        <Button
          icon="edit"
          onClick={onEditClick}
          variant={EButtonVariant.TERTIARY}
          disabled={!selectedDocument}
        >
          Редактировать
        </Button>
        <HorizontalSpace size={11} />
        {!selectedDocument?.ok ? (
          <Button
            icon="send"
            onClick={onConductClick}
            variant={EButtonVariant.TERTIARY}
            disabled={!selectedDocument}
          >
            Провести
          </Button>
        ) : (
          <Button
            icon="cancel"
            onClick={onUnConductClick}
            variant={EButtonVariant.TERTIARY}
            disabled={!selectedDocument}
          >
            Отмена проведения
          </Button>
        )}
      </div>
    </div>
  );
};
